<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid p-0">
    <div class="row">
      <upload-button-camera-noaction ref="cam" @changed="changed"></upload-button-camera-noaction>
    </div>
  </div>
</template>

<script>

  export default {
    name: "input-camera",
    components: {
      
    },
    props: {
      
    },
    data() {
      return {
        files: [],
        
      };
    },
    methods: {
      
      changed(val, text, settings) {
        this.files.push({ filesettings: settings, internalurl: val, text: text, Property: {} })
      },
      
      getId() {
        return this._uid;
      },

      init() {
        this.$refs.cam.forceRecency(false);
        this.$refs.cam.setCapture("camera");
        this.$refs.cam.setAccept("image/*");
      }
    },
    computed: {
      
    },
    watch: {
     
    },
    mounted() {
      this.init();
    },
    created() {

    },
  };

</script>



// WEBPACK FOOTER //
// src/components/form-components/input-camera.vue